export function get_stored_user() {
  const possible_keys = [
    "user",
    "auth_user",
    "current_user",
    "pending_user_data"
  ];

  for (const key of possible_keys) {
    const raw_user = sessionStorage.getItem(key) || localStorage.getItem(key);

    if (raw_user) {
      try {
        return JSON.parse(raw_user);
      } catch {
        return null;
      }
    }
  }

  return null;
}

export function is_admin_user(user) {
  const role_name = String(user?.user_role?.role?.name || "").toLowerCase();

  return Boolean(
    user?.is_superuser === true ||
    user?.is_staff === true ||
    role_name === "admin"
  );
}